<template>
  <a-layout id="components-layout-side">
    <a-layout-header class="header">
      <Header />
    </a-layout-header>
    <a-layout>
      <a-layout-sider v-model="collapsed" class="layout-sider" collapsible @collapse="onCollapse">
        <div class="layout-sider-menu"><SiderMenu /></div>
      </a-layout-sider>
      <a-layout>
        <a-layout-content class="layout-content">
          <div class="wrap">
            <div class="main">
              <router-view />
            </div>
          </div>
          <Footer />
        </a-layout-content>
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script>
import Header from '@/layouts/components/Header';
import Footer from '@/layouts/components/Footer';
import SiderMenu from '@/layouts/components/SiderMenu';
export default {
  components: { Header, SiderMenu, Footer },
  data() {
    return {
      collapsed: false
    };
  },
  methods: {
    onCollapse(collapsed) {
      this.$store.commit('setCollapsed', collapsed);
    }
  }
};
</script>

<style lang="less">
#components-layout-side {
  min-height: 100vh;
  .ant-layout-header {
    padding: 0px;
    background-color: #fff;
    height: 50px;
    border-bottom: 1px solid #e8e8e8;
  }
  .ant-layout-sider {
    padding: 0px;
    background-color: #fff;
  }

  .ant-layout-sider-trigger{
    color: #595959;
    background-color: #fff;
    border-top: 1px solid #e8e8e8;
  }
}
</style>

<style lang="less" scoped>
.header {
  height: 48px;
}
.layout-header {
  background: #fff;
  padding: 0;
  height: 48px;
}

.layout-sider-menu {
  height: calc(~'100vh - 96px');
  overflow-y: auto;
}

.layout-sider-menu::-webkit-scrollbar {
  display: none;
}

.layout-header_breadcrumb {
  margin: 16px;
  width: 1000px;
  float: left;
}

.layout-content {
  padding: 16px;
  padding-bottom: 0;
  height: calc(100vh - 50px);
  overflow-y: auto;
}
.wrap {
  min-height: 100%;
}

.main {
  padding-bottom: 32px;
}
</style>
